'use client';

import { useRouter } from 'next/navigation';

import { useTranslations } from '@northladder/i18n';
import { useAuthStore } from '@northladder/services';

import { Button } from '../../../ui';

interface ILogoutButtonProps {
  className?: string;
  size?: 'sm' | 'lg' | 'tiny' | 'icon';
  variant?: 'default' | 'outline' | 'ghost';
}

/**
 * -----------------------------------------------------------------------------
 * Common logout button component that handles session removal and redirects
 * to the login page. Used across fallback screens when session expires.
 */
export function LogoutButton({
  className,
  size = 'sm',
  variant = 'outline',
}: ILogoutButtonProps) {
  const router = useRouter();
  const { activeSession, removeSession } = useAuthStore();
  const t = useTranslations('AppErrorBoundaryView');

  const handleLogout = () => {
    if (activeSession) {
      removeSession(activeSession);
      router.replace('/login');
    }
  };

  return (
    <Button
      className={className}
      onClick={handleLogout}
      size={size}
      variant={variant}
    >
      {t('login')}
    </Button>
  );
}
